// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__1pTtI","container":"LayoutSideNavigation_container__cKOIF","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__2KmQL"};